<template>
  <div class="manage-container">
    <!--  <h3 class="base-margin__bottom-10">测试</h3>-->
    <div class="manage-container_main">
      <div class="base-flex base-flex-wrap__wrap">
        <div class="btn-group base-margin__bottom-10">
          <el-button
            :disabled="isCreating"
            :icon="isCreating ? 'el-icon-loading' : ''"
            type="primary"
            @click="showAddInstanceDialog"
            >{{ $t('customCluster.manage.addInstance') }}
          </el-button>
          <el-button :disabled="isGetList" @click="importInstances"
            >{{ $t('customCluster.manage.importInstance') }}
          </el-button>
          <el-button :disabled="multipleSelection.length === 0" @click="startInstances('batch')">
            {{ $t('customCluster.manage.batchStart') }}
          </el-button>
          <el-button :disabled="multipleSelection.length === 0" @click="stopInstances('batch')">
            {{ $t('customCluster.manage.batchStop') }}
          </el-button>
          <!--<el-button :disabled="multipleSelection.length === 0" @click="rebootInstances('batch')">{{ $t('customCluster.manage.batchReboot') }}</el-button>-->
          <el-button :disabled="multipleSelection.length === 0" @click="terminateInstances('batch')">
            {{ $t('customCluster.manage.batchTerminate') }}
          </el-button>
          <el-dropdown>
            <span class="base-margin__left-10">
              <el-button>{{ $t('customCluster.manage.more') }}<i class="el-icon-caret-bottom"></i></el-button>
              <el-button type="text"></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="multipleSelection.length === 0">
                <p class="base-cursor__pointer" @click="rebootInstances('batch')">
                  {{ $t('customCluster.manage.batchReboot') }}
                </p>
              </el-dropdown-item>
              <el-dropdown-item :disabled="tableManageData.length === 0">
                <p class="base-cursor__pointer" @click="openExportDialog">
                  {{ $t('customCluster.manage.batchExport') }}
                </p>
              </el-dropdown-item>
              <el-dropdown-item :disabled="multipleSelection.length === 0">
                <p class="base-cursor__pointer" @click="modifyInstancesChargeTypeShow('POSTPAID_BY_HOUR')">
                  {{ $t('customCluster.manage.batchToPostpaid') }}
                </p>
              </el-dropdown-item>
              <el-dropdown-item :disabled="multipleSelection.length === 0">
                <p class="base-cursor__pointer" @click="modifyInstancesChargeTypeShow('PREPAID')">
                  {{ $t('customCluster.manage.batchToPrepaid') }}
                </p>
              </el-dropdown-item>
              <el-dropdown-item :disabled="multipleSelection.length === 0">
                <p
                  class="base-cursor__pointer"
                  @click="modifyInstancesChargeTypeShow('renewInstances', multipleSelection)"
                >
                  {{ $t('customCluster.manage.batchSetAutoRenew') }}
                </p>
              </el-dropdown-item>
              <el-dropdown-item>
                <p class="base-cursor__pointer" @click="importNetworkInterface">
                  {{ $t('customCluster.manage.addNetworkInterface') }}
                </p>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="base-flex base-margin__bottom-10">
          <el-select
            v-model="typeCharge"
            :placeholder="$t('customCluster.manage.selectChargeType')"
            class="select-status"
            collapse-tags
            @change="filterSubclusterInstances('noBatch')"
          >
            <el-option v-for="item in typeChargeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select
            v-model="statusList"
            :placeholder="$t('customCluster.manage.selectStatus')"
            class="select-status"
            clearable
            collapse-tags
            @change="filterSubclusterInstances('noBatch')"
          >
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!--   批次     -->
          <BatchIndex
            ref="batchIndex"
            :batchListData="manageDataAll"
            :subclusterId="Number(this.$route.query.id)"
            @filterSubclusterInstances="filterSubclusterInstances"
          />
          <el-input
            v-model="searchInput"
            :placeholder="$t('customCluster.manage.searchPlaceholder')"
            class="base-width__240"
            clearable
            suffix-icon="el-icon-search"
            @change="filterSubclusterInstances('noBatch')"
            @keydown.enter.native="search"
          ></el-input>
          <el-button
            class="refresh base-margin__left-10"
            icon="el-icon-refresh"
            type="text"
            @click="getSubclusterInstances"
          ></el-button>
        </div>
      </div>
      <div class="table-container">
        <!-- 表格 -->
        <el-table
          ref="table"
          v-loading="isGetList"
          :data="exhibitData"
          :default-sort="{ prop: 'hostname', order: 'ascending' }"
          class="manage-table"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="46"></el-table-column>
          <el-table-column :label="$t('customCluster.manage.id')" min-width="94px">
            <template slot-scope="scope">
              <span
                class="base-color__light_blue base-cursor__pointer"
                @click="open('instance', scope.row.instanceId)"
                >{{ scope.row.instanceId }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.hostname')" min-width="120" prop="hostname" sortable>
            <template slot-scope="scope">
              <p>{{ scope.row.hostname }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.image')" min-width="120" prop="imageId" sortable>
            <template slot-scope="scope">
              <p>{{ scope.row.imageId || '-' }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('customCluster.manage.ip')"
            :sort-method="sortByPrivateIp"
            min-width="120"
            prop="privateIp"
            sortable
          >
            <template slot-scope="scope">
              <span>-</span><br /><span>{{ scope.row.privateIp }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('customCluster.manage.status')"
            min-width="120"
            prop="instanceStates"
          ></el-table-column>
          <el-table-column
            :label="$t('customCluster.manage.instanceConfig')"
            min-width="120"
            prop="instanceType"
            sortable
          ></el-table-column>
          <el-table-column :label="$t('customCluster.manage.chargeMode')" min-width="230" prop="expiredTime" sortable>
            <template slot-scope="scope">
              <p>
                {{ processCharge(scope.row.instanceChargeType) }}
                <span v-if="scope.row.renewFlag">{{ filterRenwFlagList(scope.row.renewFlag) }}</span>
              </p>
              <p
                v-if="scope.row.expiredTime"
                :style="`color: ${formatExpiredTime(scope.row.expiredTime).color}`"
                class="base-font-size__12px"
              >
                {{ formatExpiredTime(scope.row.expiredTime).expireTime }} {{ $t('customCluster.manage.expire') }}
                <el-tag
                  v-if="scope.row.expiredTime"
                  :style="`color: ${formatExpiredTime(scope.row.expiredTime).color}`"
                  :type="formatExpiredTime(scope.row.expiredTime).tag"
                  size="small"
                >
                  <span v-if="formatExpiredTime(scope.row.expiredTime).diffDays > 0">
                    剩余{{ formatExpiredTime(scope.row.expiredTime).diffDays }}天
                  </span>
                  <span v-else>
                    {{ formatExpiredTime(scope.row.expiredTime).tagValue }}
                  </span>
                </el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.batch')" min-width="50" prop="createBatchIndex">
            <template slot-scope="scope">
              {{ scope.row.createBatchIndex }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.monitor')" min-width="50">
            <template slot-scope="scope">
              <el-button
                class="base-color__grey"
                icon="el-icon-s-data base-font-size__16px"
                type="text"
                @click="open('monitor', scope.row.instanceId)"
              />
            </template>
          </el-table-column>

          <el-table-column :label="$t('customCluster.manage.createTime')" prop="createAt" width="160">
            <template slot-scope="scope">
              {{ processTime(scope.row.startAt) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.actions')" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.instanceStates === 'PENDING'">
                <i class="el-icon-loading"></i>{{ $t('customCluster.manage.initializing') }}
              </div>
              <div v-else>
                <!--续费-->
                <el-button
                  v-if="scope.row.instanceChargeType === 'PREPAID'"
                  :disabled="!(scope.row.instanceStates === 'RUNNING')"
                  type="text"
                  @click="modifyInstancesChargeTypeShow('renewInstances', [scope.row])"
                >
                  {{ $t('customCluster.manage.renew') }}
                </el-button>
                <!--销毁-->
                <el-button
                  :disabled="scope.row.lastOperationStatus === 'OPERATING'"
                  type="text"
                  @click="terminateInstances(scope.row)"
                  >{{ $t('customCluster.manage.terminate') }}
                </el-button>

                <el-dropdown>
                  <span class="base-margin__left-10">
                    <el-button type="text"
                      >{{ $t('customCluster.manage.more') }}<i class="el-icon-caret-bottom"></i
                    ></el-button>
                    <el-button type="text"></el-button>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!--开机-->
                    <el-dropdown-item
                      :disabled="
                        !(scope.row.instanceStates === 'STOPPED' && scope.row.lastOperationStatus !== 'OPERATING')
                      "
                    >
                      <p class="base-cursor__pointer" @click="startInstances(scope.row.id)">
                        {{ $t('customCluster.manage.start') }}
                      </p>
                    </el-dropdown-item>
                    <!--关机-->
                    <el-dropdown-item
                      :disabled="
                        !(scope.row.instanceStates === 'RUNNING' && scope.row.lastOperationStatus !== 'OPERATING')
                      "
                    >
                      <p class="base-cursor__pointer" @click="stopInstances(scope.row.id)">
                        {{ $t('customCluster.manage.stop') }}
                      </p>
                    </el-dropdown-item>
                    <!--重启-->
                    <el-dropdown-item
                      :disabled="
                        !(scope.row.instanceStates === 'RUNNING' && scope.row.lastOperationStatus !== 'OPERATING')
                      "
                    >
                      <p class="base-cursor__pointer" @click="rebootInstances(scope.row.id)">
                        {{ $t('customCluster.manage.reboot') }}
                      </p>
                    </el-dropdown-item>
                    <!-- 弹性网卡 -->
                    <el-dropdown-item
                      :disabled="
                        !(scope.row.instanceStates === 'RUNNING' && scope.row.lastOperationStatus !== 'OPERATING')
                      "
                    >
                      <p class="base-cursor__pointer" @click="attachNetworkInterface(scope.row)">
                        {{ $t('customCluster.manage.networkInterface') }}
                      </p>
                    </el-dropdown-item>

                    <!-- 配置升级 -->
                    <el-dropdown-item
                      :disabled="
                        !(scope.row.instanceStates === 'RUNNING' && scope.row.lastOperationStatus !== 'OPERATING')
                      "
                    >
                      <p class="base-cursor__pointer" @click="updateConfig(scope.row)">
                        {{ $t('customCluster.manage.upgradeConfig') }}
                      </p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页部分 -->
        <el-pagination
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          class="pagination"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
    <!--  导入实例  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.importInstance')"
      :visible.sync="importInstancesVisible"
      width="1000px"
    >
      <div>
        <div>
          <el-input
            v-model="filtersInstanceName"
            :placeholder="$t('customCluster.manage.enterInstanceName')"
            class="base-width__240"
            @change="importInstances"
          ></el-input>
          <el-select
            v-model="filtersInstanceState"
            :placeholder="$t('customCluster.manage.selectInstanceState')"
            class="base-width__240 base-margin__left-10"
            multiple
            @change="importInstances"
          >
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select
            v-model="filterImportableType"
            :placeholder="$t('customCluster.manage.importable')"
            class="base-width__240 base-margin__left-10"
            @change="filterImportable"
          >
            <el-option :label="$t('customCluster.manage.all')" value="all"></el-option>
            <el-option :label="$t('customCluster.manage.importable')" value="false"></el-option>
            <el-option :label="$t('customCluster.manage.notImportable')" value="true"></el-option>
          </el-select>
        </div>
        <el-table
          v-loading="importInstancesLoading"
          :data="importInstancesTableData"
          height="500"
          max-height="500"
          style="width: 100%"
          @selection-change="importInstancesHandleSelectionChange"
        >
          <el-table-column :selectable="checkSelectable" type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('customCluster.manage.instanceName')">
            <template slot-scope="scope">
              <div v-if="!scope.row.disabledImportReason">
                <span>{{ scope.row.InstanceName }}</span>
              </div>
              <div v-else>
                <el-tooltip :content="scope.row.disabledImportReason" class="item" effect="dark" placement="top-start">
                  <el-button class="base-color__grey" type="text">{{ scope.row.InstanceName }}</el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customCluster.manage.instanceId')" prop="InstanceId"></el-table-column>
          <el-table-column :label="$t('customCluster.manage.state')" prop="InstanceState"></el-table-column>
          <el-table-column :label="$t('customCluster.manage.chargeType')">
            <template slot-scope="scope">
              <span>{{
                scope.row.InstanceChargeType === 'PREPAID'
                  ? $t('customCluster.manage.prepaid')
                  : $t('customCluster.manage.postpaid')
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <p class="base-text-align__right base-margin__top-10">
          {{ $t('customCluster.manage.total') }} {{ importInstancesTableData.length }}
          {{ $t('customCluster.manage.items') }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeImportInstances">{{ $t('common.cancel') }}</el-button>
        <el-button
          :disabled="importInstancesList.length === 0"
          :loading="importInstancesLoading"
          type="primary"
          @click="doneImportInstances"
          >{{ $t('common.confirm') }}</el-button
        >
      </span>
    </el-dialog>

    <!--  导出  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.export')"
      :visible.sync="exportDialogVisible"
      width="700px"
    >
      <div>
        <el-radio-group v-model="radio" @input="checkRadio">
          <div class="base-margin__bottom-10">
            <el-radio :label="false">{{ $t('customCluster.manage.exportAll') }}</el-radio>
          </div>
          <div class="base-flex base-height__30">
            <el-radio :label="true" class="base-margin__top-10"
              >{{ $t('customCluster.manage.exportByBatch') }}
            </el-radio>

            <span class="base-height__300">
              <!--   批次     -->
              <BatchIndex
                v-show="radio"
                ref="batchIndex"
                :dialogBatchListData="dialogBatchListData"
                :subclusterId="Number(this.$route.query.id)"
                @filterSubclusterInstances="filterSubclusterInstances"
              />
            </span>
          </div>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="exportBatch()">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--  绑定弹性网卡弹窗  -->
    <el-dialog
      :title="$t('customCluster.manage.bindNetworkInterface')"
      :visible.sync="networkInterfaceVisible"
      width="800px"
    >
      <div v-loading="netWorkLoading" class="base-flex networkInterfaceCls">
        <div class="base-flex__1">
          <h4 class="base-margin__bottom-5">
            {{ $t('customCluster.manage.bound') }} ({{ $t('customCluster.manage.uncheckCancel') }})
          </h4>
          <div class="networkInterfaceCBox">
            <el-table
              ref="multipleTable"
              :data="yesNetworkInterfaceList"
              class="base-width_fullscreen"
              max-height="300"
              tooltip-effect="dark"
              @selection-change="yesNetworkInterfaceChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column :label="$t('customCluster.manage.name')">
                <template slot-scope="scope">
                  <div>{{ scope.row.NetworkInterfaceName }}</div>
                  <div>{{ scope.row.NetworkInterfaceId }}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('customCluster.manage.subnet')" prop="SubnetId"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="base-margin__left-8 base-flex__1">
          <h4 class="base-margin__bottom-5">
            {{ $t('customCluster.manage.bindable') }} ({{ $t('customCluster.manage.checkBind') }})
          </h4>
          <div class="networkInterfaceCBox">
            <el-table
              ref="multipleTable"
              :data="noNetworkInterfaceList"
              class="base-width_fullscreen"
              max-height="300"
              tooltip-effect="dark"
              @selection-change="noNetworkInterfaceChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column :label="$t('customCluster.manage.name')">
                <template slot-scope="scope">
                  <div>{{ scope.row.NetworkInterfaceName }}</div>
                  <div>{{ scope.row.NetworkInterfaceId }}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('customCluster.manage.subnet')" prop="SubnetId"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="networkInterfaceVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button
          :disabled="noNetworkInterface.length === 0 && yesNetworkInterface.length === 0"
          :loading="netWorkLoading"
          type="primary"
          @click="modifyNetworkInterface"
          >{{ $t('common.confirm') }}</el-button
        >
      </span>
    </el-dialog>

    <!--新增弹性网卡-->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.addNetworkInterface')"
      :visible.sync="addNetworkInterfaceVisible"
      width="800px"
    >
      <el-table :data="xlsxList" max-height="500" style="width: 100%">
        <el-table-column
          :label="$t('customCluster.manage.networkInterfaceName')"
          prop="networkInterfaceName"
        ></el-table-column>
        <el-table-column :label="$t('customCluster.manage.primaryIp')">
          <template slot-scope="scope">
            <div v-if="scope.row.privateIpAddressesMaster.length === 0">
              {{ $t('customCluster.manage.autoAssign') }}
            </div>
            <span v-for="(item, index) in scope.row.privateIpAddressesMaster" v-else :key="index">
              <span> {{ item?.privateIpAddress || $t('customCluster.manage.autoAssign') }}<br /> </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.manage.secondaryIp')">
          <template slot-scope="scope">
            <div>
              <p
                v-for="item in scope.row.secondaryPrivateIpAddressCount - scope.row.privateIpAddressesNumber"
                :key="item"
              >
                {{ $t('customCluster.manage.autoAssign') }}
              </p>
            </div>
            <span v-for="(item, index) in scope.row.privateIpAddresses" :key="index">
              <span> {{ item?.privateIpAddress || $t('customCluster.manage.autoAssign') }}<br /> </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.manage.securityGroup')">
          <template slot-scope="scope">
            <div v-if="scope.row.securityGroupIds.length === 0">-</div>
            <span v-for="(item, index) in scope.row.securityGroupIds" v-else :key="index"> {{ item }}<br /> </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.actions')" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click.native.prevent="deleteRow(scope.$index, xlsxList)">
              {{ $t('common.remove') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="base-flex__row-reverse">
        <el-button
          :disabled="xlsxList.length === 0"
          :loading="doneNetworkInterfaceLoading"
          class="base-margin__left-10"
          type="primary"
          @click="doneNetworkInterface"
          >{{ $t('common.confirmSubmit') }}</el-button
        >
        <el-button @click="openAddDialog">{{ $t('common.add') }}</el-button>
        <el-upload
          :file-list="uploadFileList"
          :limit="1"
          :on-change="jsonFileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
          action=""
        >
          <el-button>{{ $t('customCluster.manage.batchUpload') }}</el-button>
        </el-upload>
        <el-button class="base-margin__right-10" type="text" @click="downloadTemplate">{{
          $t('customCluster.manage.downloadTemplate')
        }}</el-button>
      </span>
    </el-dialog>

    <addInstanceDialog
      ref="addInstanceDialog"
      v-loading.fullscreen.lock="isCreating"
      :element-loading-text="$t('customCluster.manage.creatingInstance')"
      :getSubclusterInstances="getSubclusterInstances"
      :showLoading="showLoading"
      :subclusterId="Number(this.$route.query.id)"
    />
    <!--  按量转包年包月  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="modifyInstancesChargeTypeTitle"
      :visible.sync="modifyInstancesChargeTypeVisible"
      @close="closeRenewInstanseDialog"
      :destroy-on-close="true"
      z-index="1001"
      width="600px"
    >
      <el-form
        ref="form"
        v-loading="modifyInstancesChargeTypeVisibleLoading"
        :model="instancesChargeForm"
        label-position="left"
        label-width="80px"
      >
        <div v-if="instancesChargeForm.instanceChargeType === 'PREPAID'">
          <el-form-item :label="$t('customCluster.manage.renewDuration')">
            <el-select
              v-model="instancesChargeForm.period"
              :placeholder="$t('customCluster.manage.selectRenewDuration')"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('customCluster.manage.autoRenew')">
            <el-checkbox
              v-model="instancesChargeForm.automatic"
              false-label="NOTIFY_AND_MANUAL_RENEW"
              true-label="NOTIFY_AND_AUTO_RENEW"
            >
              <span class="base-color__light_grey base-width_fullscreen base-flex-wrap__wrap">
                {{ $t('customCluster.manage.autoRenewTip') }}
              </span>
            </el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('customCluster.manage.storage')">
            <span class="base-color__light_grey">
              {{ $t('customCluster.manage.storageTip') }}
              <el-tooltip
                :content="$t('customCluster.manage.storageTooltip')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </span>
          </el-form-item>
        </div>
        <div v-else class="base-margin__left-20 base-margin__bottom-10">
          <ul style="list-style-type: decimal">
            <li>{{ $t('customCluster.manage.postpaidTip1') }}</li>
            <li>{{ $t('customCluster.manage.postpaidTip2') }}</li>
            <li>{{ $t('customCluster.manage.postpaidTip3') }}</li>
            <li class="base-color__red">
              {{ $t('customCluster.manage.postpaidTip4') }}
            </li>
            <li class="base-color__red">
              {{ $t('customCluster.manage.postpaidTip5') }}
            </li>
          </ul>
        </div>
        <el-form-item label="">
          <el-checkbox v-model="instancesChargeForm.delivery">
            <span class="base-color__light_grey"
              >{{ $t('customCluster.manage.agree') }}
              <el-button type="text" @click="openRule">{{
                instancesChargeForm.instanceChargeType === 'PREPAID'
                  ? $t('customCluster.manage.postpaidToPrepaidRule')
                  : $t('customCluster.manage.prepaidToPostpaidRule')
              }}</el-button>
            </span>
          </el-checkbox>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-popover placement="top" trigger="click" width="800" :offset="1">
          <el-table :data="multipleSelection" class="base-margin__bottom-20" max-height="400">
            <el-table-column :label="$t('customCluster.manage.hostname')" prop="hostname"></el-table-column>
            <el-table-column :label="$t('customCluster.manage.instance')">
              <template slot-scope="scope">
                {{ scope.row.instanceType || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customCluster.manage.systemDisk')" prop="diskType">
              <template slot-scope="scope">
                {{ filterDiskType(scope.row.diskType) || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customCluster.manage.systemDiskSize')">
              <template slot-scope="scope"> {{ scope.row.diskSize || '-' }}GIB </template>
            </el-table-column>
            <el-table-column
              v-if="!projectPriceBlacklist.includes(projectId.toString())"
              :label="$t('customCluster.manage.price')"
              prop="unitPriceDiscount"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.unitPriceDiscount }}
                </span>
                <span class="base-margin__right-10">{{
                  instancesChargeForm.instanceChargeType === 'POSTPAID_BY_HOUR'
                    ? $t('customCluster.manage.yuanPerHour')
                    : $t('customCluster.manage.yuanPerMonth')
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            slot="reference"
            :disabled="modifyInstancesChargeTypeVisibleLoading"
            class="base-margin__right-10 base-margin__left-10"
            type="text"
            >{{ $t('customCluster.manage.costPreview') }}</el-button
          >
        </el-popover>
        <el-button @click="modifyInstancesChargeTypeVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button
          :disabled="!instancesChargeForm.delivery"
          :loading="modifyInstancesChargeTypeLoading"
          type="primary"
          @click="changeInstancesChargeType"
        >
          {{ $t('customCluster.manage.convertNow') }}
        </el-button>
      </span>
    </el-dialog>
    <!--  弹性网卡  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.networkInterface')"
      :visible.sync="addNetworkDialogVisible"
      width="610px"
    >
      <el-form
        ref="form"
        v-loading="addNetworkLoading"
        :model="addNetworkForm"
        label-position="left"
        label-width="110px"
      >
        <el-form-item :label="$t('customCluster.manage.networkInterfaceName')">
          <el-input
            v-model="addNetworkForm.networkInterfaceName"
            :placeholder="$t('customCluster.manage.enterNetworkInterfaceName')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('customCluster.manage.network')">
          <p>
            <span
              class="base-color__light_blue base-cursor__pointer"
              @click="openTyx('vpc', subclusterDetailInfo.vpcId, subclusterDetailInfo.region)"
              >{{ subclusterDetailInfo.vpcId }}
            </span>
            <span>| {{ subclusterDetailInfo.vpcName }}</span>
          </p>
        </el-form-item>
        <el-form-item :label="$t('customCluster.manage.network')">
          <p>
            <span
              class="base-color__light_blue base-cursor__pointer"
              @click="openTyx('subnet', subclusterDetailInfo.subnetId, subclusterDetailInfo.region)"
            >
              {{ subclusterDetailInfo.subnetId }}
            </span>
            <span> | ( {{ subclusterDetailInfo.subnetName }} | {{ subclusterDetailInfo.subnetCidr }}) </span>
          </p>
        </el-form-item>
        <el-form-item :label="$t('customCluster.manage.assignIp')">
          <div class="base-flex">
            <div class="base-margin__right-10">{{ $t('customCluster.manage.primaryIp') }}</div>
            <el-select
              v-model="addNetworkForm.masterIpSelect"
              class="base-width__120 base-margin__left-14 base-margin__right-10"
              @change="masterIpSelectChange"
            >
              <el-option :label="$t('customCluster.manage.autoAssign')" :value="false"></el-option>
              <el-option :label="$t('customCluster.manage.manualInput')" :value="true"></el-option>
            </el-select>
            <el-input
              v-if="addNetworkForm.masterIpSelect"
              v-model="addNetworkForm.masterIp.privateIpAddress"
              :placeholder="$t('customCluster.manage.enterPrimaryIp')"
              class="base-width__200"
            ></el-input>
            <span v-else>{{ $t('customCluster.manage.autoAssignTip') }}</span>
          </div>

          <div v-for="(item, index) in addNetworkForm.assistIp" :key="index" class="base-flex base-margin__top-5">
            <div class="base-margin__right-10">{{ $t('customCluster.manage.secondaryIp') }}</div>
            <el-select
              v-model="item.assistIpSelect"
              class="base-width__120 base-margin__right-10"
              @change="assistIpSelectChange(item.assistIpSelect, index)"
            >
              <el-option :label="$t('customCluster.manage.autoAssign')" :value="false"></el-option>
              <el-option :label="$t('customCluster.manage.manualInput')" :value="true"></el-option>
            </el-select>
            <el-input
              v-if="item.assistIpSelect"
              v-model="item.privateIpAddress"
              :placeholder="$t('customCluster.manage.enterSecondaryIp')"
              class="base-width__200"
            ></el-input>
            <span v-else>{{ $t('customCluster.manage.autoAssignTip') }}</span>
            <el-button class="base-margin__left-10" type="text" @click="deleteAssistIp(index)"
              >{{ $t('common.remove') }}
            </el-button>
          </div>

          <el-button type="text" @click="addAssistIpNumber">{{ $t('customCluster.manage.addSecondaryIp') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('customCluster.manage.securityGroup')">
          <el-select
            v-model="addNetworkForm.securityGroupIds"
            :placeholder="$t('customCluster.manage.selectSecurityGroup')"
            multiple
          >
            <el-option
              v-for="item in securityGroupOption"
              :key="item.SecurityGroupId"
              :label="`${item.SecurityGroupName} | ${item.SecurityGroupId}`"
              :value="item.SecurityGroupId"
            >
              <span>{{ item.SecurityGroupName }} | {{ item.SecurityGroupId }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addNetworkDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="doneAddNetworkInterface">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--  调整配置  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.adjustConfig')"
      :visible.sync="updateConfigDialogVisible"
      width="1200px"
      :destroy-on-close="true"
      z-index="1001"
    >
      <div v-loading="updateConfigLoading">
        <div class="steps_cls">
          <el-steps :active="stepsActive" class="steps" space="400px">
            <el-step :title="$t('customCluster.manage.selectTargetConfig')"></el-step>
            <el-step :title="$t('customCluster.manage.shutdownNotice')"></el-step>
          </el-steps>
        </div>
        <div v-show="stepsActive === 1">
          <div class="base-flex">
            <el-select v-model="instanceCpuValue" class="base-width__240" clearable @change="instanceValueSelect">
              <el-option
                v-for="item in instanceCpuOptions"
                :key="item"
                :label="`${item}${$t('customCluster.manage.cores')}`"
                :value="item"
              ></el-option>
            </el-select>
            <el-select
              v-model="instanceMemoryValue"
              class="base-width__240 base-margin__left-16"
              clearable
              @change="instanceValueSelect"
            >
              <el-option
                v-for="item in instanceMemoryOptions"
                :key="item"
                :label="`${item}${$t('customCluster.manage.gb')}`"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="instanceTypeInput"
              :placeholder="$t('customCluster.manage.enterSpec')"
              class="base-width__240 base-margin__left-16"
              clearable
              @input="instanceValueSelect"
            ></el-input>
          </div>

          <!--  调整配置 table -->
          <el-table
            ref="singleTable"
            :data="newInstanceTypeTable"
            :row-class-name="tableRowClassName"
            class="newInstanceTypeTable_cls"
            highlight-current-row
            @row-click="newInstanceTypeTableHandleCurrentChange"
            @cell-mouse-enter="tableRowMouseEnter"
          >
            <el-table-column :label="$t('customCluster.manage.select')" align="center" width="65">
              <template slot-scope="scope">
                <el-radio
                  v-model="newInstanceTypeRadio"
                  :disabled="!scope.row.rowDisabled"
                  :label="scope.row.index"
                  class="instanceTypeRadio"
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('customCluster.manage.spec')"
              prop="InstanceTypeConfig.InstanceType"
            ></el-table-column>
            <el-table-column :label="$t('customCluster.manage.vcpu')">
              <template slot-scope="scope">
                {{ scope.row.InstanceTypeConfig.CPU }}{{ $t('customCluster.manage.cores') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customCluster.manage.memory')">
              <template slot-scope="scope">
                {{ scope.row.InstanceTypeConfig.Memory }}{{ $t('customCluster.manage.gb') }}
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="instanceTypeTotalCount"
            align="right"
            class="pagination"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="instanceTypeTableHandleSizeChange"
            @current-change="instanceTypeTableOnCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="stepsActive === 2" class="stepsActive_3-cls">
        <p>
          <i class="el-icon-warning"></i><span>{{ $t('customCluster.manage.shutdownRequired') }}</span>
        </p>
        <ul>
          <li>{{ $t('customCluster.manage.shutdownTip1') }}</li>
          <li>{{ $t('customCluster.manage.shutdownTip2') }}</li>
          <li>{{ $t('customCluster.manage.shutdownTip3') }}</li>
        </ul>
      </div>
      <div v-show="stepsActive === 2" class="base-margin__top-20">
        <span class="base-font-size__12px base-color__grey">
          {{ $t('customCluster.manage.forceShutdown') }}
          <span class="base-margin__right-5 base-color__red">*</span>
          <span
            ><el-checkbox v-model="shutdownCheckbox" class="base-font-size__12px base-color__grey">{{
              $t('customCluster.manage.agreeForceShutdown')
            }}</el-checkbox></span
          >
        </span>
      </div>
      <div v-show="stepsActive === 1 && priceNone" class="base-margin__top-20">
        <span class="base-font-size__12px base-color__grey">{{ $t('customCluster.manage.freezeFee') }} </span>
        <span v-if="!priceLoading">
          <span class="price_cls">{{ instanceTypePrice }}</span>
          {{
            updateConfigFrom.instanceChargeType === 'PREPAID'
              ? $t('customCluster.addInstanceDialog.yuanPerMonth')
              : $t('customCluster.addInstanceDialog.yuanPerHour')
          }}
        </span>
        <i v-else class="el-icon-loading"></i>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateConfigDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button v-show="stepsActive !== 1" @click="stepsActive--">{{
          $t('customCluster.manage.previous')
        }}</el-button>
        <el-button
          v-show="stepsActive !== 2"
          :disabled="instanceTypePrice === 0"
          type="primary"
          @click="stepsActive++"
          >{{ $t('customCluster.manage.next') }}</el-button
        >
        <el-button
          v-show="stepsActive === 2"
          :disabled="instanceTypePrice === 0 || !shutdownCheckbox"
          :loading="priceLoading"
          type="primary"
          @click="newInstanceTypeAdjustConfig(selectRow, 'done', 'newInstanceTypeTableHandleCurrentChange')"
          >{{ $t('common.confirm') }}</el-button
        >
      </span>
    </el-dialog>

    <!--设置自动续费弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.manage.setAutoRenew')"
      :visible.sync="renewInstancesDialogVisible"
      width="900px"
      @close="closeRenewInstanseDialog"
    >
      <div v-loading="renewInstancesLoading" class="base-margin__bottom-10 base-font-size__12px">
        <div v-if="renewInstancesStep === 0">
          <div class="instancesRenew-cls">
            <ul style="list-style-type: decimal">
              <li>
                {{ $t('customCluster.manage.autoRenewTip1') }}
                <span class="base-color__orange">{{ $t('customCluster.manage.autoRenew') }}</span>
                {{ $t('customCluster.manage.autoRenewTip2') }}
              </li>
              <li>
                <div class="base-flex">
                  <span>{{ $t('customCluster.manage.autoRenewTip3') }}</span>
                  <el-link class="base-font-size__12px" type="primary" @click="windowOpenLink">
                    {{ $t('customCluster.manage.voucherDesc') }}
                    <i class="el-icon-view el-icon--right"></i>
                  </el-link>
                </div>
              </li>
              <li>{{ $t('customCluster.manage.autoRenewTip4') }}</li>
              <li>{{ $t('customCluster.manage.autoRenewTip5') }}</li>
            </ul>
          </div>
          <div class="base-flex base-margin__top-20">
            <div>
              <el-form ref="form" :model="renewInstancesForm" label-position="left" label-width="100px">
                <el-form-item :label="$t('customCluster.manage.renewDuration')">
                  <div class="base-flex">
                    <el-radio-group
                      v-model="renewInstancesForm.period"
                      class="base-flex"
                      @input="changePeriod('radio')"
                    >
                      <el-radio-button
                        v-for="(item, index) in renewInstancesPeriodOptions"
                        :key="index"
                        :label="item.value"
                      >
                        {{ item.label }}
                      </el-radio-button>
                    </el-radio-group>
                    <el-select
                      v-model="renewInstancesForm.selectPeriod"
                      class="base-width__120 base-margin__left-10"
                      @change="changePeriod('select')"
                    >
                      <el-option
                        v-for="item in renewInstancesPeriodDropdown"
                        v-show="item.value !== null"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="">
                  <el-checkbox v-model="renewInstancesForm.renewPortableDataDisk">
                    <span class="base-color__light_grey base-width_fullscreen base-flex-wrap__wrap">
                      {{ $t('customCluster.manage.renewPortableDataDisk') }}
                      <el-tooltip effect="dark" placement="top-start">
                        <div slot="content" class="text-wrapper">
                          {{ $t('customCluster.manage.renewPortableDataDiskTips') }}
                        </div>
                        <i class="el-icon-warning-outline"></i>
                      </el-tooltip>
                    </span>
                  </el-checkbox>
                </el-form-item>
                <div class="base-flex base-margin__top-20">
                  <div class="base-font-size__14px">{{ $t('customCluster.manage.instanceAutoRenew') }}:</div>
                  <div class="base-flex__column-center base-margin__left-10">
                    <el-radio
                      v-model="renewInstancesForm.renewFlag"
                      class="base-margin__bottom-10"
                      label="NOTIFY_AND_AUTO_RENEW"
                      >{{ $t('customCluster.manage.enableAutoRenew') }}
                    </el-radio>
                    <el-radio
                      v-model="renewInstancesForm.renewFlag"
                      class="base-margin__bottom-10"
                      label="NOTIFY_AND_MANUAL_RENEW"
                    >
                      {{ $t('customCluster.manage.disableAutoRenew1')
                      }}<span class="base-color__orange">{{ $t('customCluster.manage.disableAutoRenew2') }}</span
                      >{{ $t('customCluster.manage.disableAutoRenew3') }}
                    </el-radio>
                    <el-radio
                      v-model="renewInstancesForm.renewFlag"
                      class="base-flex-wrap__wrap"
                      label="DISABLE_NOTIFY_AND_MANUAL_RENEW"
                    >
                      {{ $t('customCluster.manage.disableAutoRenew4')
                      }}<span class="base-color__orange">{{ $t('customCluster.manage.disableAutoRenew5') }}</span
                      >{{ $t('customCluster.manage.disableAutoRenew6') }}
                    </el-radio>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div v-if="renewInstancesStep === 1">
          <el-table :data="multipleSelection" class="base-margin__bottom-20 base-min-height__300" max-height="400">
            <el-table-column :label="$t('customCluster.manage.hostname')" prop="hostname"></el-table-column>
            <el-table-column :label="$t('customCluster.manage.instance')">
              <template slot-scope="scope">
                {{ scope.row.instanceType || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customCluster.manage.autoRenew')">
              <template>
                {{
                  renewInstancesForm.renewFlag === 'NOTIFY_AND_AUTO_RENEW'
                    ? $t('computingCluster.detailsInfo.enable')
                    : $t('computingCluster.detailsInfo.disable')
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customCluster.manage.renewDuration')">
              <template>
                {{ renewInstancesForm.period || renewInstancesForm.selectPeriod || 0 }}
                {{ $t('customCluster.baseInfo.months') }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="!projectPriceBlacklist.includes(projectId.toString())"
              :label="$t('customCluster.addInstanceDialog.unitPrice')"
              prop="unitPriceDiscount"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.unitPriceDiscount }}
                </span>
                <span class="base-margin__right-10">{{ $t('customCluster.manage.yuanPerMonth') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="!projectPriceBlacklist.includes(projectId.toString())"
              :label="$t('createNode.totalPrice')"
            >
              <template slot-scope="scope">
                <span class="base-color__orange">
                  <span>
                    {{
                      (
                        scope.row.unitPriceDiscount * (renewInstancesForm.period || renewInstancesForm.selectPeriod)
                      ).toFixed(2)
                    }}
                    {{ $t('common.yuan') }}
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renewInstancesDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button v-if="renewInstancesStep === 1" @click="renewInstancesStep--">{{
          $t('customCluster.manage.previous')
        }}</el-button>
        <el-button
          v-if="renewInstancesStep === 0"
          :disabled="renewInstancesLoading"
          type="primary"
          @click="renewInstancesStep++"
          >{{ $t('customCluster.manage.next') }}</el-button
        >
        <el-button
          v-if="renewInstancesStep === 1"
          :loading="modifyInstancesRenewFlagLoading"
          type="primary"
          @click="doneModifyInstancesRenewFlag"
        >
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!--订单确认-->
    <orderConfirmation ref="orderConfirmation" @finishOrder="finishOrder" />
  </div>
</template>

<script>
import { use } from '@tencent/tea-sdk-runner';
import { postRequest } from '@/common/libs/request';
import addInstanceDialog from '@/views/customCluster/customDetail/addInstanceDialog';
import BatchIndex from '@/components/batchIndex/index.vue';
import { regionMap } from '@/common/constants';
import {
  debounce,
  exportData,
  filterDiskType,
  filterRenwFlagList,
  processCharge,
  processTime,
} from '@/common/utils/utils';
import { setupMfaSdk } from '@/common/libs/setupMfaSdk';
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import { mapGetters, mapState } from 'vuex';
import orderConfirmation from '@/components/orderConfirmation';

export default {
  name: 'manage',
  data() {
    return {
      importInstancesVisible: false,
      importInstancesTableData: [],
      defaultImportInstancesTableData: [],
      importInstancesList: [],
      importInstancesLoading: false,
      filtersInstanceName: '',
      filtersInstanceState: [],
      id: '',
      MFACode: '',
      total: 0,
      dialogVisible: false,
      manageData: [],
      manageDataAll: [],
      tableManageData: [],
      dialogBatchListData: [],
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [],
      searchInput: '',
      region: '',
      zone: '',
      vpcId: '',
      subnetId: '',
      isCreating: false,
      statusList: [],
      oldStatusList: [],
      statusOptions: [
        { label: this.$t('customCluster.manage.creating'), value: 'PENDING' },
        { label: this.$t('customCluster.manage.createFailed'), value: 'LAUNCH_FAILED' },
        { label: this.$t('customCluster.manage.running'), value: 'RUNNING' },
        { label: this.$t('customCluster.manage.stopped'), value: 'STOPPED' },
        { label: this.$t('customCluster.manage.starting'), value: 'STARTING' },
        { label: this.$t('customCluster.manage.stopping'), value: 'STOPPING' },
        { label: this.$t('customCluster.manage.rebooting'), value: 'REBOOTING' },
        { label: this.$t('customCluster.manage.shutdown'), value: 'SHUTDOWN' },
        { label: this.$t('customCluster.manage.terminating'), value: 'TERMINATING' },
      ],
      filterImportableType: 'all',
      typeCharge: 'all',
      typeChargeList: [
        { label: this.$t('customCluster.manage.all'), value: 'all' },
        { label: this.$t('customCluster.manage.postpaid'), value: 'POSTPAID_BY_HOUR' },
        { label: this.$t('customCluster.manage.prepaidAutoRenew'), value: 'NOTIFY_AND_AUTO_RENEW' },
        { label: this.$t('customCluster.manage.prepaidManualRenew'), value: 'NOTIFY_AND_MANUAL_RENEW' },
        { label: this.$t('customCluster.manage.prepaidNoRenew'), value: 'DISABLE_NOTIFY_AND_MANUAL_RENEW' },
      ],
      batchIndex: [],
      oldBatchIndex: [],
      options: [],
      searchType: 'name',
      authType: 1,
      searchOptions: [
        { label: this.$t('customCluster.manage.privateIp'), value: 'ip' },
        { label: this.$t('customCluster.manage.name'), value: 'name' },
      ],
      isGetList: false,
      loginType: sessionStorage.getItem('loginType'),
      exportDialogVisible: false,
      radio: false,
      mfaSdk: null, // MFA SDK
      networkInterfaceVisible: false,
      netWorkLoading: false,
      noNetworkInterface: [],
      noNetworkInterfaceList: [],
      yesNetworkInterface: [],
      yesNetworkInterfaceList: [],
      addNetworkInterfaceVisible: false,
      uploadFileList: [],
      xlsxList: [],
      cvmData: [],
      modifyInstancesChargeTypeVisible: false,
      modifyInstancesChargeTypeVisibleLoading: false,
      modifyInstancesChargeTypeTitle: this.$t('customCluster.manage.postpaidToPrepaid'),
      instancesChargeForm: {
        period: 1,
        delivery: false,
        automatic: 'NOTIFY_AND_MANUAL_RENEW',
        instanceChargeType: 'POSTPAID_BY_HOUR',
      },
      timeOptions: [
        { text: this.$t('customCluster.manage.oneMonth'), value: 1 },
        { text: this.$t('customCluster.manage.twoMonths'), value: 2 },
        { text: this.$t('customCluster.manage.threeMonths'), value: 3 },
        { text: this.$t('customCluster.manage.fourMonths'), value: 4 },
        { text: this.$t('customCluster.manage.fiveMonths'), value: 5 },
        { text: this.$t('customCluster.manage.sixMonths'), value: 6 },
        { text: this.$t('customCluster.manage.sevenMonths'), value: 7 },
        { text: this.$t('customCluster.manage.eightMonths'), value: 8 },
        { text: this.$t('customCluster.manage.nineMonths'), value: 9 },
        { text: this.$t('customCluster.manage.tenMonths'), value: 10 },
        { text: this.$t('customCluster.manage.elevenMonths'), value: 11 },
        { text: this.$t('customCluster.manage.oneYear'), value: 12 },
        { text: this.$t('customCluster.manage.twoYears'), value: 24 },
        { text: this.$t('customCluster.manage.threeYears'), value: 36 },
        { text: this.$t('customCluster.manage.fourYears'), value: 48 },
        { text: this.$t('customCluster.manage.fiveYears'), value: 60 },
      ],
      addNetworkDialogVisible: false,
      addNetworkForm: {
        networkInterfaceName: '',
        masterIp: {
          primary: true,
          privateIpAddress: '',
        },
        securityGroupIds: [],
        masterIpSelect: false,
        assistIp: [],
      },
      securityGroupOption: [],
      subclusterDetailInfo: [],
      addNetworkLoading: false,
      modifyInstancesChargeTypeLoading: false,

      oldInstanceTypeTable: [],
      newInstanceTypeTable: [],
      neutralInstanceTypeTable: [],
      instanceTypeTotalCount: 0,
      instanceTypeTablePages: 1,
      instanceTypeTableSize: 10,
      instanceCpuOptions: [],
      instanceCpuValue: '',

      instanceMemoryOptions: [],
      instanceMemoryValue: '',
      instanceTypeInput: '',
      newInstanceTypeRadio: '',
      instanceTypePrice: 0,
      priceLoading: false,
      priceNone: false,
      shutdownCheckbox: false,
      selectRow: {},

      updateConfigDialogVisible: false,
      updateConfigLoading: false,
      stepsActive: 1,
      updateConfigFrom: {},
      doneNetworkInterfaceLoading: false,
      dayjs,
      processCharge,
      filterRenwFlagList,
      filterDiskType,
      processTime,
      defaultFilterList: [],
      exhibitData: [],
      // 分页相关
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 排序相关
      sortParams: {
        prop: 'hostname',
        order: 'ascending',
      },
      projectPriceBlacklist: sessionStorage.getItem('projectPriceBlacklist').split(',') || [], // 项目价格黑名单
      projectId: JSON.parse(sessionStorage.getItem('currentProject')).id || 0, // 当前项目ID
      renewInstancesDialogVisible: false, // 续费实例弹窗
      renewInstancesForm: {
        period: 0,
        selectPeriod: null,
        renewFlag: 'NOTIFY_AND_AUTO_RENEW',
        subclusterInstanceIdList: [],
        subclusterId: 0,
        renewPortableDataDisk: false,
      },
      modifyInstancesRenewFlagLoading: false,
      renewInstancesStep: 0,
      renewInstancesPeriodOptions: [
        { label: this.$t('customCluster.manage.zeroMonth'), value: 0 },
        { label: this.$t('customCluster.manage.oneMonth'), value: 1 },
        { label: this.$t('customCluster.manage.twoMonths'), value: 2 },
        { label: this.$t('customCluster.manage.threeMonths'), value: 3 },
        { label: this.$t('customCluster.manage.oneYear'), value: 12 },
        { label: this.$t('customCluster.manage.twoYears'), value: 24 },
        { label: this.$t('customCluster.manage.threeYears'), value: 36 },
        { label: this.$t('customCluster.manage.fourYears'), value: 48 },
        { label: this.$t('customCluster.manage.fiveYears'), value: 60 },
      ],
      renewInstancesPeriodDropdown: [
        { label: '更多时长', value: null },
        { label: this.$t('customCluster.manage.fourMonths'), value: 4 },
        { label: this.$t('customCluster.manage.fiveMonths'), value: 5 },
        { label: this.$t('customCluster.manage.sixMonths'), value: 6 },
        { label: this.$t('customCluster.manage.sevenMonths'), value: 7 },
        { label: this.$t('customCluster.manage.eightMonths'), value: 8 },
        { label: this.$t('customCluster.manage.nineMonths'), value: 9 },
        { label: this.$t('customCluster.manage.tenMonths'), value: 10 },
        { label: this.$t('customCluster.manage.elevenMonths'), value: 11 },
      ],
      renewInstancesLoading: false, // 续费实例弹窗加载状态
    };
  },
  components: {
    addInstanceDialog,
    BatchIndex,
    orderConfirmation,
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
      }
    },
  },
  async mounted() {
    this.getSubclusterInstances();
    this.loginType = sessionStorage.getItem('loginType');
    // 如果是腾讯云用户
    if (this.loginType === 'cloud') {
      await setupMfaSdk();
    }
  },
  computed: {
    filters() {
      let filter = [];
      if (this.statusList.length === 0 && this.batchIndex.length === 0) {
        filter = [];
      } else if (this.statusList.length !== 0 && this.batchIndex.length === 0) {
        filter.push({ name: 'instance-state', values: this.statusList });
      } else if (this.statusList.length === 0 && this.batchIndex.length !== 0) {
        filter.push({ name: 'creation-batch-index', values: this.batchIndex });
      } else if (this.statusList.length !== 0 && this.batchIndex.length !== 0) {
        filter.push(
          { name: 'instance-state', values: this.statusList },
          { name: 'creation-batch-index', values: this.batchIndex },
        );
      }
      return filter;
    },
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  methods: {
    // 打开导入实例弹窗
    importInstances() {
      this.importInstancesLoading = true;
      const data = {
        region: this.region,
        offSet: 0,
        limit: 100,
        filters: [
          {
            Name: 'zone',
            Values: [this.zone],
          },
          {
            Name: 'vpc-id',
            Values: [this.vpcId],
          },
          {
            Name: 'subnet-id',
            Values: [this.subnetId],
          },
          {
            Name: 'instance-state',
            Values: this.filtersInstanceState,
          },
          {
            Name: 'instance-name',
            Values: this.filtersInstanceName.length === 0 ? [] : [this.filtersInstanceName],
          },
        ],
      };
      this.importInstancesVisible = true;
      postRequest('/api/eda/common/tencentcloud/describeInstances', data)
        .then((res) => {
          const list = res?.instanceList || [];
          list.forEach((item) => {
            if (item.Tags?.length) {
              const tags = item.Tags;
              let projectId = '';
              let subclusterId = '';
              tags.forEach((tag) => {
                if (tag.Key === 'openeda') {
                  projectId = tag?.Value.split('-')[1] || '';
                }
                if (tag.Key === `openeda-${projectId}`) {
                  subclusterId = tag?.Value.split('-')[2] || '';
                }
              });
              if (projectId) {
                item.disabledImport = true;
                item.disabledImportReason = subclusterId
                  ? this.$t('customCluster.manage.instanceExistsInSubcluster', { projectId, subclusterId })
                  : this.$t('customCluster.manage.instanceImportedByProject', { projectId });
              }
            }
          });
          this.defaultImportInstancesTableData = list || [];
          this.importInstancesTableData = list || [];
          this.importInstancesLoading = false;
        })
        .catch(() => {
          this.importInstancesLoading = false;
          this.importInstancesVisible = false;
        });
    },

    filterImportable() {
      switch (this.filterImportableType) {
        case 'all':
          this.importInstancesTableData = this.defaultImportInstancesTableData;
          break;
        case 'false':
          this.importInstancesTableData = this.defaultImportInstancesTableData.filter(item => !item.disabledImport);
          break;
        case 'true':
          this.importInstancesTableData = this.defaultImportInstancesTableData.filter(item => item.disabledImport);
          break;
      }
    },

    // IP地址排序方法
    sortByPrivateIp(a, b) {
      const ipA = a.privateIp.split('.').map(Number);
      const ipB = b.privateIp.split('.').map(Number);
      for (let i = 0; i < 4; i++) {
        if (ipA[i] !== ipB[i]) {
          return ipA[i] - ipB[i];
        }
      }
      return 0;
    },

    // 是否可以选择  table 的 checkbox
    checkSelectable(row) {
      return !row.disabledImport;
    },

    // 多选导入实例
    importInstancesHandleSelectionChange(val) {
      this.importInstancesList = val.map(item => item.InstanceId);
    },
    // 取消导入实例
    closeImportInstances() {
      this.importInstancesVisible = false;
    },

    // 确定导入实例
    doneImportInstances() {
      this.importInstancesLoading = true;
      postRequest('/api/eda/common/subcluster/importSubclusterInstances', {
        subclusterId: Number(this.$route.query.id),
        instanceIdList: this.importInstancesList,
      })
        .then(() => {
          this.importInstancesLoading = false;
          this.importInstancesVisible = false;
          this.$message.success(this.$t('customCluster.manage.importSuccess'));
          // 重新获取实例列表
          this.getSubclusterInstances();
        })
        .catch(() => {
          this.importInstancesLoading = false;
        });
    },

    // 处理分页变化
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.handleSortChange({
        prop: this.sortParams.prop,
        order: this.sortParams.order,
      });
    },
    // 处理排序变化
    handleSortChange({ prop, order }) {
      // 只处理指定的排序字段
      const sortFields = ['hostname', 'imageId', 'instanceType', 'expiredTime', 'privateIp'];
      if (sortFields.includes(prop)) {
        this.sortParams = { prop, order };
        this.updateDisplayData();
      }
    },

    // 更新展示数据(包含排序和分页)
    updateDisplayData() {
      // 1. 复制原始数据
      const data = JSON.parse(JSON.stringify(this.defaultFilterList));

      if (this.sortParams.prop && this.sortParams.order) {
        data.sort((a, b) => {
          const valueA = a[this.sortParams.prop] || '';
          const valueB = b[this.sortParams.prop] || '';

          // 在Vue组件中的IP地址排序实现
          if (this.sortParams.prop === 'privateIp') {
            const compareResult = this.ipCompare(valueA, valueB);
            return this.sortParams.order === 'ascending' ? compareResult : -compareResult;
          }

          // 其他字段保持原样
          return this.sortParams.order === 'ascending' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });
      }

      // 3. 执行分页
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;

      const list = JSON.parse(JSON.stringify(data.slice(start, end)));
      this.pagination.total = data.length;

      // eslint-disable-next-line no-undef
      this.exhibitData = list;
      // 3. 强制刷新表格

      // 在数据更新后强制表格重新渲染
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.doLayout) {
          this.$refs.table.doLayout();
        }
      });
    },

    ipCompare(a, b) {
      // 处理空值情况
      if (!a && !b) return 0;
      if (!a) return -1;
      if (!b) return 1;

      // 将IP地址转换为数值数组
      const aParts = a.split('.').map(Number);
      const bParts = b.split('.').map(Number);

      // 逐段比较四个部分
      for (let i = 0; i < 4; i++) {
        if (aParts[i] !== bParts[i]) {
          return aParts[i] - bParts[i]; // 直接数值比较
        }
      }
      return 1;
    },

    /**
     * 修改辅助IP类型·
     * */
    assistIpSelectChange(item, index) {
      if (!item) {
        this.addNetworkForm.assistIp[index].privateIpAddress = '';
      }
    },
    /**
     * 修改主IP类型·
     * */
    masterIpSelectChange() {
      if (!this.addNetworkForm.masterIpSelect) {
        this.addNetworkForm.masterIp.privateIpAddress = '';
      }
    },
    /**
     * 删除辅助IP·
     * */
    deleteAssistIp(index) {
      this.addNetworkForm.assistIp.splice(index, 1);
    },
    /**
     * 新增辅助IP个数·
     * */
    addAssistIpNumber() {
      this.addNetworkForm.assistIp.push({
        primary: false,
        privateIpAddress: '',
        assistIpSelect: false,
      });
    },

    /**
     * 新增单个弹性网卡·
     * */
    doneAddNetworkInterface() {
      const ipv4Pattern
        = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      new Promise((resolve, reject) => {
        if (this.addNetworkForm.networkInterfaceName === '') {
          this.$message.warning(this.$t('customCluster.manage.enterNetworkInterfaceName'));
          reject();
        }

        if (this.addNetworkForm.masterIp.privateIpAddress !== '') {
          if (!ipv4Pattern.test(this.addNetworkForm.masterIp.privateIpAddress)) {
            this.$message.warning(this.$t('customCluster.manage.invalidPrimaryIp'));
            reject();
          }
        }

        if (this.addNetworkForm.securityGroupIds.length === 0) {
          this.$message.warning(this.$t('customCluster.manage.selectSecurityGroup'));
          reject();
        }

        this.addNetworkForm.assistIp.map((item, index) => {
          if (item.privateIpAddress !== '') {
            if (!ipv4Pattern.test(item.privateIpAddress)) {
              this.$message.warning(this.$t('customCluster.manage.invalidSecondaryIp', { index: index + 1 }));
              reject();
            }
          }
        });
        resolve();
      }).then(() => {
        this.xlsxList.push({
          networkInterfaceName: this.addNetworkForm.networkInterfaceName,
          securityGroupIds: this.addNetworkForm.securityGroupIds,
          secondaryPrivateIpAddressCount: this.addNetworkForm.assistIp.length,
          privateIpAddresses: this.addNetworkForm.assistIp,
          privateIpAddressesMaster: [this.addNetworkForm.masterIp],
          privateIpAddressesNumber: this.addNetworkForm.assistIp.length,
        });

        this.addNetworkDialogVisible = false;
      });
    },

    /**
     * 打开新增单个弹性网卡弹窗·
     * */
    openAddDialog() {
      this.addNetworkForm = {
        networkInterfaceName: '',
        masterIp: {
          primary: true,
          privateIpAddress: '',
        },
        securityGroupIds: [],
        masterIpSelect: false,
        assistIp: [],
      };
      this.securityGroupOption = [];
      this.subclusterDetailInfo = [];
      this.addNetworkLoading = true;

      postRequest('/api/eda/common/tencentcloud/describeSecurityGroupList', {
        region: this.region,
      }).then((res) => {
        this.securityGroupOption = res.securityGroup;
      });

      // 获取子集群详情
      this.subclusterDetailDisabled = true;
      postRequest('/api/eda/common/subcluster/getSubclusterDetail', {
        subclusterId: Number(this.$route.query.id),
      }).then((res) => {
        this.subclusterDetailInfo = res.subclusterDetail;
        this.addNetworkLoading = false;
      });
      this.addNetworkDialogVisible = true;
    },

    /**
     * 打开按量转包年包月规则
     * */
    openRule() {
      if (this.instancesChargeForm.instanceChargeType === 'POSTPAID_BY_HOUR') {
        window.open('https://cloud.tencent.com/document/product/213/67765');
      } else {
        window.open('https://cloud.tencent.com/document/product/213/2762');
      }
    },
    /**
     * 修改计费方式 按量转包年包月  包年包月转按量计费
     * */
    modifyInstancesChargeTypeShow(type, val) {
      if (type === 'POSTPAID_BY_HOUR') {
        this.modifyInstancesChargeTypeVisibleLoading = true;
        this.modifyInstancesChargeTypeVisible = true;
        this.modifyInstancesChargeTypeTitle = this.$t('customCluster.manage.prepaidToPostpaid');
        this.instancesChargeForm = {
          delivery: false,
          instanceChargeType: type,
        };
      }
      if (type === 'PREPAID') {
        this.modifyInstancesChargeTypeVisibleLoading = true;
        this.modifyInstancesChargeTypeVisible = true;
        this.modifyInstancesChargeTypeTitle = this.$t('customCluster.manage.postpaidToPrepaid');
        this.instancesChargeForm = {
          period: 1,
          delivery: false,
          automatic: 'NOTIFY_AND_MANUAL_RENEW',
          instanceChargeType: type,
        };
      }

      if (type === 'renewInstances') {
        this.renewInstancesForm = {
          period: 0,
          selectPeriod: null,
          renewFlag: 'NOTIFY_AND_AUTO_RENEW',
          subclusterInstanceIdList: [],
          subclusterId: 0,
          renewPortableDataDisk: false,
        };
        this.handleSelectionChange(val);
        this.renewInstancesLoading = true;
        this.renewInstancesDialogVisible = true;
      }

      if (this.multipleSelection.length !== 0) {
        // 1. 先按 instanceType 分组，避免重复请求
        const typeGroups = {};
        this.multipleSelection.forEach((item) => {
          if (item.instanceChargeType === type) return;
          if (!typeGroups[item.instanceType]) {
            typeGroups[item.instanceType] = [];
          }
          typeGroups[item.instanceType].push(item);
        });

        // 2. 为每种 instanceType 只发送一次请求
        const uniqueRequests = Object.keys(typeGroups).map((instanceType) => {
          const sampleItem = typeGroups[instanceType][0]; // 取组内第一个作为代表
          const data = {
            DiskSize: sampleItem.diskSize || 500,
            DiskType: sampleItem.diskType || 'CLOUD_BSSD',
            ImageId: sampleItem.imageId,
            InstanceChargeType: type === 'renewInstances' ? 'PREPAID' : type,
            InstanceType: instanceType,
            Region: this.region,
            Zone: this.zone,
          };

          return postRequest('/api/eda/common/tencentcloud/inquiryInstancePrice', data).then(res =>
            // 3. 将相同结果应用到同类型的所有项
            typeGroups[instanceType].map(item => ({ ...item, ...res })));
        });

        // 4. 等待所有唯一请求完成
        Promise.all(uniqueRequests)
          .then((results) => {
            // 5. 合并所有结果
            const allResults = results.flat();
            this.multipleSelection = allResults;
            this.modifyInstancesChargeTypeVisibleLoading = false;
            this.renewInstancesLoading = false;
          })
          .catch((error) => {
            console.error('请求出错:', error);
            this.$message.error(this.$t('customCluster.manage.priceFetchFailed'));
            this.modifyInstancesChargeTypeVisibleLoading = false;
            this.renewInstancesLoading = false;
          });
      }
    },

    // 点击显示订单确认
    changeInstancesChargeType() {
      if (this.multipleSelection.length === 0) return this.$message.warning(this.$t('customCluster.manage.unsupportedChargeTypeChange', { title: this.modifyInstancesChargeTypeTitle }));
      const list = [];
      this.multipleSelection.map((item) => {
        list.push({
          instanceType: item.instanceType,
          nodeCount: 1,
          nodePrice: item.unitPriceDiscount,
          totalPrice: item.unitPriceDiscount * 1,
          priceUnit:
            this.instancesChargeForm.instanceChargeType === 'POSTPAID_BY_HOUR'
              ? this.$t('customCluster.addInstanceDialog.yuanPerHour')
              : this.$t('customCluster.addInstanceDialog.yuanPerMonth'),
        });
      });
      this.$refs.orderConfirmation.showOrderConfirmation({ list });
    },

    /**
     * 保存按量转包年包月
     * */
    modifyInstancesChargeType() {
      this.modifyInstancesChargeTypeLoading = true;
      const list = [];
      this.multipleSelection.map((item) => {
        // if (item.instanceChargeType === this.instancesChargeForm.instanceChargeType) return;
        list.push(item.id);
      });

      const data = {
        subclusterId: +this.$route.query.id,
        period: this.instancesChargeForm.period,
        instanceChargeType: this.instancesChargeForm.instanceChargeType,
        subclusterInstanceIdList: list,
        renewFlag: this.instancesChargeForm.automatic,
      };

      if (list.length === 0) {
        this.$message.warning(this.$t('customCluster.manage.unsupportedChargeTypeChange', { title: this.modifyInstancesChargeTypeTitle }));
        this.modifyInstancesChargeTypeLoading = false;
        return false;
      }
      postRequest('/api/eda/common/subcluster/modifyInstancesChargeType', data)
        .then(() => {
          this.$message.success(this.$t('customCluster.manage.chargeTypeChangeSuccess', { title: this.modifyInstancesChargeTypeTitle }));
          this.modifyInstancesChargeTypeVisible = false;
          this.modifyInstancesChargeTypeLoading = false;
          this.getSubclusterInstances();
        })
        .catch(() => {
          this.modifyInstancesChargeTypeLoading = false;
        });
    },

    /**
     * 设置续费月份
     * */
    changePeriod(type) {
      if (type === 'radio') {
        this.renewInstancesForm.selectPeriod = null;
      } else if (type === 'select') {
        this.renewInstancesForm.period = null;
      }
    },

    /**
     * 确定设置自动续费
     * */
    async doneModifyInstancesRenewFlag() {
      this.modifyInstancesRenewFlagLoading = true;
      const list = [];
      this.multipleSelection.map((item) => {
        if (item.instanceChargeType === 'POSTPAID_BY_HOUR') return;
        list.push(item.id);
      });

      const data = {
        ...this.renewInstancesForm,
        subclusterId: +this.$route.query.id,
        subclusterInstanceIdList: list,
        period: this.renewInstancesForm.period || this.renewInstancesForm.selectPeriod,
      };

      if (list.length === 0) {
        this.$message.warning(this.$t('customCluster.manage.unsupportedAutoRenew'));
        this.modifyInstancesRenewFlagLoading = false;
        return false;
      }

      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/subcluster/renewInstances', data)
          .then(() => {
            this.$message.success(this.$t('customCluster.manage.autoRenewSetSuccess'));
            this.renewInstancesDialogVisible = false;
            this.modifyInstancesRenewFlagLoading = false;
            this.getSubclusterInstances();
          })
          .catch(() => {
            this.modifyInstancesRenewFlagLoading = false;
          });
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk
            .verify({ api: 'cvm:ModifyInstancesRenewFlag' })
            .then(() => {
              // 展示确认弹窗
              postRequest('/api/eda/common/subcluster/renewInstances', data)
                .then(() => {
                  this.$message.success(this.$t('customCluster.manage.autoRenewSetSuccess'));
                  this.renewInstancesDialogVisible = false;
                  this.modifyInstancesRenewFlagLoading = false;
                  this.getSubclusterInstances();
                })
                .catch(() => {
                  this.modifyInstancesRenewFlagLoading = false;
                });
            })
            .catch((e) => {
              console.log(333, e, e.innerError);
              this.modifyInstancesRenewFlagLoading = false;
            });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('customCluster.manage.mfaAuthFailed'),
          });
          this.modifyInstancesRenewFlagLoading = false;
        }
      }
    },

    /**
     * excel数据转为json数组  展示table数据
     * */
    async jsonFileList(file) {
      if (file.status !== 'ready') return;
      this.fileToExcel(file, this)
        .then((res) => {
          this.xlsxList = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * excel数据转为json数组
     * */
    async fileToExcel(file, that) {
      return new Promise((resolve, reject) => {
        // 不使用 Promise 也可以 只是把读文件做成异步更合理
        const reader = new FileReader();
        reader.onload = function (e) {
          // 拿到file数据
          const { result } = e.target;
          // XLSX 解析的配置  type: 'binary' 必写
          const excelData = XLSX.read(result, { type: 'binary' });
          // 注意要加 { header: 1 }, 此配置项 可生成二维数组
          const data = XLSX.utils.sheet_to_json(excelData.Sheets[excelData.SheetNames[0]]); // ! 读取去除工作簿中的数据
          const newList = data.map((item) => {
            const excelJson = {
              networkInterfaceName: item[that.$t('customCluster.manage.networkInterfaceNameExcel')] || '',
              secondaryPrivateIpAddressCount: item[that.$t('customCluster.manage.secondaryIpCountExcel')] || 0,
              privateIpAddresses: [],
              securityGroupIds: item[that.$t('customCluster.manage.securityGroupExcel')]?.split('\r\n') || [],
              privateIpAddressesMaster: [],
              privateIpAddressesNumber: 0,
            };

            if (item[that.$t('customCluster.manage.primaryIpExcel')]) {
              excelJson.privateIpAddressesMaster.push({
                primary: true,
                privateIpAddress: item[that.$t('customCluster.manage.primaryIpExcel')].split('\r\n')[0],
              });
            }

            if (item[that.$t('customCluster.manage.secondaryIpExcel')]) {
              item[that.$t('customCluster.manage.secondaryIpExcel')].split('\r\n')?.map((list) => {
                excelJson.privateIpAddresses.push({
                  primary: false,
                  privateIpAddress: list,
                });
              });
            }

            if (excelJson.privateIpAddresses.length - 1 > excelJson.secondaryPrivateIpAddressCount) {
              reject(that.$t('customCluster.manage.secondaryIpCountError'));
            }

            excelJson.privateIpAddressesNumber = excelJson.privateIpAddresses.length;

            return excelJson;
          });
          resolve(newList);
        };
        // 调用方法  读取二进制字符串
        reader.readAsBinaryString(file.raw);
      });
    },

    /**
     * 确定新增网卡
     */
    doneNetworkInterface() {
      const createDetails = this.xlsxList.map((item) => {
        item.privateIpAddresses = [...item.privateIpAddresses, ...item.privateIpAddressesMaster];
        return item;
      });

      this.doneNetworkInterfaceLoading = true;
      postRequest('/api/eda/common/subcluster/sendNetworkInterfaceTask', {
        subclusterId: Number(this.$route.query.id),
        action: 'create',
        createDetails,
      })
        .then(() => {
          this.$message.warning(this.$t('customCluster.manage.networkInterfaceCreating'));
          this.doneNetworkInterfaceLoading = false;
          this.addNetworkInterfaceVisible = false;
        })
        .catch(() => {
          this.doneNetworkInterfaceLoading = false;
        });
    },

    /**
     * 下载模板
     */
    downloadTemplate() {
      window.open(
        'https://eda-static-cdn-1300241787.file.myqcloud.com/build/api/public/networkInterfaceTemplate.xlsx',
        '_self',
      );
    },

    /**
     * 移除table网卡数据
     */
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    /**
     * 新增网卡
     */
    importNetworkInterface() {
      this.xlsxList = [];
      this.addNetworkInterfaceVisible = true;
    },

    /**
     * 跳转腾讯云查看详情
     */
    openTyx(type, val, region) {
      if (val === '') return false;
      switch (type) {
        case 'vpc':
          window.open(`https://console.cloud.tencent.com/vpc/vpc/detail?rid=${regionMap.get(region)}&id=${val}`);
          break;
        case 'subnet':
          window.open(`https://console.cloud.tencent.com/vpc/subnet/detail?rid=${regionMap.get(region)}&id=${val}`);
          break;
      }
    },

    /**
     * 配置升级
     */
    async updateConfig(data) {
      this.updateConfigFrom = data;
      this.id = data.id;
      this.stepsActive = 1;
      this.instanceTypeTotalCount = 0;
      this.instanceTypeTablePages = 1;
      this.instanceTypeTableSize = 10;
      this.instanceMemoryValue = '';
      this.instanceTypeInput = '';
      this.newInstanceTypeRadio = '';
      this.instanceTypePrice = 0;
      this.priceLoading = false;
      this.priceNone = false;
      this.shutdownCheckbox = false;
      this.selectRow = {};
      if (this.loginType === 'qq') {
        this.getInstanceTypeList(data);
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk
            .verify({ api: 'cvm:ResetInstancesType' })
            .then(() => {
              // 展示弹窗
              this.getInstanceTypeList(data);
            })
            .catch((e) => {
              console.log(333, e, e.innerError);
            });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('customCluster.manage.mfaAuthFailed'),
          });
        }
      }
    },

    /**
     * 绑定弹性网卡
     */
    attachNetworkInterface(data) {
      this.noNetworkInterfaceList = [];
      this.yesNetworkInterfaceList = [];
      this.noNetworkInterface = [];
      this.yesNetworkInterface = [];
      this.networkInterfaceVisible = true;
      this.netWorkLoading = true;
      this.id = data.id;

      postRequest('/api/eda/common/subcluster/describeNetworkInterfaces', {
        subclusterId: Number(this.$route.query.id),
      })
        .then((res) => {
          res?.networkInterfaces.map((item) => {
            if (item?.Attachment?.InstanceId === data.instanceId) {
              this.yesNetworkInterfaceList.push(item);
            }
            if (!item?.Attachment) {
              this.noNetworkInterfaceList.push(item);
            }
          });
          this.netWorkLoading = false;
        })
        .catch(() => {
          this.netWorkLoading = false;
        });
    },

    yesNetworkInterfaceChange(val) {
      this.yesNetworkInterface = val;
    },
    noNetworkInterfaceChange(val) {
      this.noNetworkInterface = val;
    },
    /**
     * 确定绑定弹性网卡
     */
    async modifyNetworkInterface() {
      this.netWorkLoading = true;
      // 绑定
      if (this.noNetworkInterface.length > 0) {
        const idList = [];
        this.noNetworkInterface.map((item) => {
          idList.push(item.NetworkInterfaceId);
        });
        postRequest('/api/eda/common/subcluster/sendNetworkInterfaceTask', {
          subclusterId: Number(this.$route.query.id),
          action: 'attach',
          attachDetachTaskDetail: {
            subclusterInstanceId: this.id,
            networkInterfaceIdList: idList,
          },
        })
          .then(() => {
            this.netWorkLoading = false;
            this.$message.warning(this.$t('customCluster.manage.networkInterfaceBinding'));
            this.networkInterfaceVisible = false;
          })
          .catch(() => {
            this.netWorkLoading = false;
          });
      }

      // 解除绑定
      if (this.yesNetworkInterface.length > 0) {
        const idList = [];
        this.yesNetworkInterface.map((item) => {
          idList.push(item.NetworkInterfaceId);
        });
        postRequest('/api/eda/common/subcluster/sendNetworkInterfaceTask', {
          subclusterId: Number(this.$route.query.id),
          action: 'detach',
          attachDetachTaskDetail: {
            subclusterInstanceId: this.id,
            networkInterfaceIdList: idList,
          },
        })
          .then(() => {
            this.netWorkLoading = false;
            this.$message.warning(this.$t('customCluster.manage.networkInterfaceUnbinding'));
            this.networkInterfaceVisible = false;
          })
          .catch(() => {
            this.netWorkLoading = false;
          });
      }
    },

    // 展示对应的确认弹窗
    showVerifyDialog(capi, val) {
      switch (capi) {
        case 'cvm:TerminateInstances':
          this.terminate(val);
          break;
        case 'cvm:StopInstances':
          this.stop();
          break;
        case 'cvm:RebootInstances':
          this.reboot();
          break;
      }
    },
    // 筛选list
    filterSubclusterInstances(batchIndex) {
      if (batchIndex !== 'noBatch') {
        this.batchIndex = batchIndex || [];
      }
      const data = JSON.parse(JSON.stringify(this.manageData));
      const filterList = [];
      data.map((list) => {
        if (this.statusList !== '' && list.instanceStates !== this.statusList) {
          return;
        }
        if (this.batchIndex.length > 0 && !this.batchIndex.includes(list.createBatchIndex.toString())) {
          return;
        }

        // 当有搜索输入且主机名、实例类型和镜像ID都不包含搜索内容时，跳过当前项
        if (
          this.searchInput !== undefined
          && this.searchInput !== ''
          && ![list.hostname, list.instanceType, list.imageId].some(field => field.includes(this.searchInput))
        ) {
          return;
        }

        // 计费类型筛选映射表
        const chargeTypeFilterMap = {
          all: () => true, // 全部类型不过滤
          POSTPAID_BY_HOUR: item => item.instanceChargeType === 'POSTPAID_BY_HOUR',
          NOTIFY_AND_AUTO_RENEW: item => item.instanceChargeType === 'PREPAID' && item.renewFlag === 'NOTIFY_AND_AUTO_RENEW',
          NOTIFY_AND_MANUAL_RENEW: item => item.instanceChargeType === 'PREPAID' && item.renewFlag === 'NOTIFY_AND_MANUAL_RENEW',
          DISABLE_NOTIFY_AND_MANUAL_RENEW: item => item.instanceChargeType === 'PREPAID' && item.renewFlag === 'DISABLE_NOTIFY_AND_MANUAL_RENEW',
        };

        // 如果筛选类型不在映射表中或不符合条件，则过滤掉
        if (this.typeCharge !== 'all' && !chargeTypeFilterMap[this.typeCharge]?.(list)) {
          return;
        }

        filterList.push(list);
      });

      this.pagination.pageSize = 10;
      this.pagination.currentPage = 1;
      this.pagination.total = filterList.length;
      this.defaultFilterList = filterList;
      this.handleSortChange(this.sortParams);
      this.pagination.total = filterList.length;
      this.tableManageData = filterList;
    },

    /**
     * 打开导出弹窗
     */
    openExportDialog() {
      this.batchIndex = [];
      this.radio = false;
      this.exportDialogVisible = true;
    },

    /**
     * 导出数据
     */
    checkRadio(val) {
      if (val === true) {
        this.$refs.batchIndex.resetBatchIndex();
        this.isKeepImage = true;
        this.dialogBatchListData = this.manageDataAll;
      }
      if (val === false) {
        this.password = '';
        this.nextPassword = '';
        this.isKeepImage = false;
      }
    },

    /**
     * 导出数据
     */
    exportBatch() {
      const arr = [];
      this.batchIndex.forEach((item) => {
        arr.push(item[0]);
      });
      const data = {
        subclusterId: [Number(this.$route.query.id)],
        batchIndex: arr,
      };
      postRequest('/api/eda/common/subcluster/exportHostname', data).then(async (res) => {
        this.exportDialogVisible = false;
        if (!res.relationList || res.relationList.length === 0) {
          return this.$message.warning(this.$t('customCluster.manage.noData'));
        }
        const result = res.relationList.map(item => ({
          hostname: item.hostname,
          ip: item.ip,
          region: item.region,
          instance_id: item.instance_id,
        }));
        await exportData(result, 'data');
      });
    },

    // 分页
    handleSizeChange(pageSize) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = pageSize;
      this.handleSortChange({
        prop: this.sortParams.prop,
        order: this.sortParams.order,
      });
    },

    // 获取列表
    getSubclusterInstances() {
      this.multipleSelection = [];
      this.oldStatusList = this.statusList;
      this.oldBatchIndex = this.batchIndex;
      this.isGetList = true;
      if (!this.$route.query.id) return;
      const data = {
        subclusterId: Number(this.$route.query.id),
      };
      setTimeout(() => {
        postRequest('/api/eda/common/subcluster/getSubclusterInstancesOnline', data)
          .then((res) => {
            this.isGetList = false;
            this.total = res?.totalCount || 0;
            this.region = res?.region || '';
            this.zone = res?.zone || '';
            this.vpcId = res?.vpcId || '';
            this.subnetId = res?.subnetId || '';
            this.manageData = res?.subclusterInstanceList || [];
            this.manageDataAll = res;
            this.filterSubclusterInstances('noBatch');
          })
          .catch(() => {
            this.isGetList = false;
          });
      }, 1000);
    },

    // 关闭续费弹窗
    closeRenewInstanseDialog() {
      this.multipleSelection = [];
      this.$refs.table.clearSelection();
      this.renewInstancesStep = 0;
      this.renewInstancesDialogVisible = false;
    },

    // 销毁 验证mfa
    async terminateInstances(val) {
      this.id = val?.id || val;
      let canOperated = true;
      this.multipleSelection.forEach((item) => {
        if (
          item.instanceStates !== 'RUNNING'
          && item.instanceStates !== 'STOPPED'
          && item.instanceStates !== 'TERMINATED'
          && item.instanceStates !== 'SHUTDOWN'
        ) {
          canOperated = false;
        }
      });
      if (!canOperated) {
        return this.$message.warning(this.$t('customCluster.manage.onlyRunningOrStoppedCanTerminate'));
      }
      if (this.loginType === 'qq') {
        this.terminate(val);
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk.verify({ api: 'cvm:TerminateInstances' }).then(() => {
            // 展示确认弹窗
            this.showVerifyDialog('cvm:TerminateInstances', val);
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('customCluster.manage.mfaAuthFailed'),
          });
        }
      }
    },

    // 销毁
    terminate(val) {
      let data
        = val.instanceStates === 'SHUTDOWN'
          ? this.$t('customCluster.manage.terminateWarning1')
          : this.$t('customCluster.manage.terminateWarning2');
      if (val.instanceChargeType !== 'PREPAID') {
        data = this.$t('customCluster.manage.terminateWarning3');
      }
      this.$confirm(data, this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      })
        .then(() => {
          const subclusterInstanceIdList = [];
          if (this.id === 'batch') {
            const defaultType = this.multipleSelection[0].instanceChargeType;

            for (let i = 0; i < this.multipleSelection.length; i++) {
              if (this.multipleSelection[i].instanceChargeType === defaultType) {
                subclusterInstanceIdList.push(this.multipleSelection[i].id);
              } else {
                return this.$message.warning(this.$t('customCluster.manage.mixedChargeTypeNotSupported'));
              }
            }
          } else {
            subclusterInstanceIdList.push(this.id);
          }
          this.$message.warning(this.$t('customCluster.manage.terminateTaskSubmitted'));
          const data = {
            subclusterId: Number(this.$route.query.id),
            subclusterInstanceIdList,
          };

          postRequest('/api/eda/common/subcluster/terminateInstances', data).then(() => {
            this.$notify({
              title: this.$t('common.tip'),
              message: this.$t('customCluster.addInstanceDialog.createSuccess'),
              type: 'success',
              customClass: 'notification-style',
              duration: 0,
            });
            setTimeout(() => {
              this.getSubclusterInstances();
            }, 500);
          });
        })
        .catch(() => {});
    },

    // 关机
    async stopInstances(val) {
      this.id = val;
      let canOperated = true;
      this.multipleSelection.forEach((item) => {
        if (item.instanceStates !== 'RUNNING') {
          canOperated = false;
        }
      });
      if (!canOperated) {
        return this.$message.warning(this.$t('customCluster.manage.onlyRunningCanStop'));
      }
      if (this.loginType === 'qq') {
        this.stop();
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk.verify({ api: 'cvm:StopInstances' }).then(() => {
            // 展示确认弹窗
            this.showVerifyDialog('cvm:StopInstances');
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('customCluster.manage.mfaAuthFailed'),
          });
        }
      }
    },

    stop() {
      this.$confirm(this.$t('customCluster.manage.stopConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      })
        .then(() => {
          this.$message.warning(this.$t('customCluster.manage.stopping'));
          const subclusterInstanceIdList = [];
          if (this.id === 'batch') {
            this.multipleSelection.forEach((item) => {
              subclusterInstanceIdList.push(item.id);
            });
          } else {
            subclusterInstanceIdList.push(this.id);
          }
          const data = {
            subclusterId: Number(this.$route.query.id),
            subclusterInstanceIdList,
          };
          postRequest('/api/eda/common/subcluster/stopInstances', data).then(() => {
            this.getSubclusterInstances();
          });
        })
        .catch(() => {});
    },

    // 开机
    startInstances(val) {
      let canOperated = true;
      this.multipleSelection.forEach((item) => {
        if (item.instanceStates !== 'STOPPED') {
          canOperated = false;
        }
      });
      if (!canOperated) {
        return this.$message.warning(this.$t('customCluster.manage.onlyStoppedCanStart'));
      }
      this.$message.warning(this.$t('customCluster.manage.starting'));
      const subclusterInstanceIdList = [];
      if (val === 'batch') {
        this.multipleSelection.forEach((item) => {
          subclusterInstanceIdList.push(item.id);
        });
      } else {
        subclusterInstanceIdList.push(val);
      }
      const data = {
        subclusterId: Number(this.$route.query.id),
        subclusterInstanceIdList,
      };
      postRequest('/api/eda/common/subcluster/startInstances', data).then(() => {
        this.getSubclusterInstances();
      });
    },

    // 重启
    async rebootInstances(val) {
      this.id = val;
      let canOperated = true;
      this.multipleSelection.forEach((item) => {
        if (item.instanceStates !== 'RUNNING') {
          canOperated = false;
        }
      });
      if (!canOperated) {
        return this.$message.warning(this.$t('customCluster.manage.onlyRunningCanReboot'));
      }
      if (this.loginType === 'qq') {
        this.reboot();
      } else {
        if (!this.mfaSdk) {
          this.mfaSdk = await use('mfa-sdk');
        }
        this.mfaSdk.verify({ api: 'cvm:RebootInstances' }).then(() => {
          // 展示确认弹窗
          this.showVerifyDialog('cvm:RebootInstances');
        });
      }
    },

    reboot() {
      this.$confirm(this.$t('customCluster.manage.rebootConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      })
        .then(() => {
          this.$message.warning(this.$t('customCluster.manage.rebooting'));
          const subclusterInstanceIdList = [];
          if (this.id === 'batch') {
            this.multipleSelection.forEach((item) => {
              subclusterInstanceIdList.push(item.id);
            });
          } else {
            subclusterInstanceIdList.push(this.id);
          }
          const data = {
            subclusterId: Number(this.$route.query.id),
            subclusterInstanceIdList,
          };
          postRequest('/api/eda/common/subcluster/rebootInstances', data).then(() => {
            this.getSubclusterInstances();
          });
        })
        .catch(() => {});
    },

    // 多选集群列表
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 打开新增实例弹窗
    showAddInstanceDialog() {
      this.$refs.addInstanceDialog.dialogVisible = true;
    },

    showLoading(val) {
      this.isCreating = val;
    },

    search(e) {
      e.target.blur();
    },

    /**
     * 打开实例详情页面
     */
    open(type, val) {
      switch (type) {
        case 'instance':
          window.open(`https://console.cloud.tencent.com/cvm/instance/detail?searchParams=rid%3D33&rid=${regionMap.get(this.region)}&id=${val}`);
          break;
        case 'monitor':
          window.open(`https://console.cloud.tencent.com/cvm/instance/detail?searchParams=rid%3D33&rid=${regionMap.get(this.region)}&id=${val}&tab=monitor`);
          break;
      }
    },

    /**
     * 获取机型列表
     */
    getInstanceTypeList(data) {
      this.updateConfigDialogVisible = true;
      this.updateConfigLoading = true;
      this.cvmData = new Map();
      postRequest('/api/eda/common/subcluster/describeInstanceModification', {
        subclusterId: Number(this.$route.query.id),
        subclusterInstanceId: data.id,
      }).then((res) => {
        this.oldInstanceTypeTable = res?.instanceTypeConfigStatus || [];
        this.instanceTypeTotalCount = res?.totalCount || 0;

        // 使用 Set 存储唯一的 Memory 和 cpu
        const uniqueMemorys = new Set();
        const uniqueCpus = new Set();

        res?.instanceTypeConfigStatus.forEach((item) => {
          uniqueMemorys.add(item.InstanceTypeConfig.Memory);
          uniqueCpus.add(item.InstanceTypeConfig.CPU);
        });

        // 将 Set 转换为数组
        this.instanceCpuOptions = Array.from(uniqueCpus).sort((a, b) => a - b);
        this.instanceMemoryOptions = Array.from(uniqueMemorys).sort((a, b) => a - b);

        this.vuePagination();
        this.updateConfigLoading = false;
      });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     */
    instanceTypeTableOnCurrentChange(page) {
      this.instanceTypeTablePages = page;
      this.vuePagination();
    },

    // 前端分页
    vuePagination() {
      this.newInstanceTypeRadio = '';
      this.instanceTypePrice = 0;
      if (this.instanceMemoryValue !== '' || this.instanceCpuValue !== '' || this.instanceTypeInput !== '') {
        const list = JSON.parse(JSON.stringify(this.neutralInstanceTypeTable.slice(
          (this.instanceTypeTablePages - 1) * this.instanceTypeTableSize,
          this.instanceTypeTablePages * this.instanceTypeTableSize,
        )));
        list.map((item, index) => {
          item.index = index + 1;
          if (item.Status === 'SOLD_OUT') {
            item.InstanceTypeConfig.InstanceType = `${item.InstanceTypeConfig.InstanceType} (${this.$t('customCluster.manage.soldOut')})`;
          }
          if (item.Status === 'SELL') {
            item.rowDisabled = true;
          }
        });
        this.newInstanceTypeTable = list;
      } else {
        const list = JSON.parse(JSON.stringify(this.oldInstanceTypeTable.slice(
          (this.instanceTypeTablePages - 1) * this.instanceTypeTableSize,
          this.instanceTypeTablePages * this.instanceTypeTableSize,
        )));
        list.map((item, index) => {
          item.index = index + 1;
          if (item.Status === 'SOLD_OUT') {
            item.InstanceTypeConfig.InstanceType = `${item.InstanceTypeConfig.InstanceType} (${this.$t('customCluster.manage.soldOut')})`;
          }
          if (item.Status === 'SELL') {
            item.rowDisabled = true;
          }
        });
        this.newInstanceTypeTable = list;
      }
    },

    /**
     * 修改禁用行的样式
     */
    tableRowClassName({ row }) {
      if (!row.rowDisabled) {
        return 'warning-row';
      }
      return 'success-row';
    },

    tableRowMouseEnter(row, column, cell) {
      cell.title = row.Message || '';
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    instanceTypeTableHandleSizeChange(pageSize) {
      this.instanceTypeTablePages = 1;
      this.instanceTypeTableSize = pageSize;
      this.vuePagination();
    },

    /**
     * 筛选相同Memory GB CPU核数
     */
    instanceValueSelect() {
      const data = JSON.parse(JSON.stringify(this.oldInstanceTypeTable));
      const filterList = [];
      data.map((list) => {
        if (this.instanceMemoryValue !== '' && list.InstanceTypeConfig.Memory !== this.instanceMemoryValue) {
          return;
        }

        if (this.instanceCpuValue !== '' && list.InstanceTypeConfig.CPU !== this.instanceCpuValue) {
          return;
        }

        if (
          this.instanceTypeInput !== 'undefined'
          && list.InstanceTypeConfig.InstanceType.indexOf(this.instanceTypeInput) === -1
        ) {
          return;
        }
        filterList.push(list);
      });

      this.instanceTypeTablePages = 1;
      this.instanceTypeTableSize = 10;
      this.newInstanceTypeTable = filterList;
      this.neutralInstanceTypeTable = filterList;
      this.instanceTypeTotalCount = filterList.length || 0;
      this.vuePagination();
    },

    /**
     * 选择配置 获取价格 调整配置
     */
    newInstanceTypeAdjustConfig(row, status, functionName) {
      const info = {
        functionInfo: {
          functionName,
          row,
          status,
        },
        type: true,
        list: [
          {
            instanceType: row.InstanceTypeConfig.InstanceType,
            nodeCount: 1,
            nodePrice: this.instanceTypePrice,
            totalPrice: this.instanceTypePrice.toFixed(2),
            priceUnit:
              this.updateConfigFrom.instanceChargeType === 'POSTPAID_BY_HOUR'
                ? this.$t('customCluster.addInstanceDialog.yuanPerHour')
                : this.$t('customCluster.addInstanceDialog.yuanPerMonth'),
          },
        ],
      };
      this.$refs.orderConfirmation.showOrderConfirmation(info);
    },

    // 订单确认
    finishOrder(info) {
      if (info) {
        this[info.functionName](info.row, info.status);
      } else {
        this.modifyInstancesChargeType();
      }
    },

    /**
     * 获取价格
     */
    newInstanceTypeTableHandleCurrentChange(row, status) {
      if (!row.rowDisabled) return;
      this.priceLoading = true;
      this.priceNone = true;
      this.newInstanceTypeRadio = row.index || '';
      this.$refs.singleTable.setCurrentRow(row);
      debounce(() => {
        const params = {
          ...this.updateConfigFrom,
          region: this.region,
          zone: this.zone,
          subclusterId: Number(this.$route.query.id),
          subclusterInstanceId: this.id,
          instanceType:
            status === 'done' ? this.selectRow.InstanceTypeConfig.InstanceType : row.InstanceTypeConfig.InstanceType,
          tryRun: status !== 'done',
        };
        postRequest('/api/eda/common/tencentcloud/inquiryInstancePrice', params)
          .then((res) => {
            this.instanceTypePrice = res.unitPriceDiscount || res.instancePrice.InstancePrice.DiscountPrice;
            this.selectRow = row;
            this.priceLoading = false;
            if (status === 'done') {
              this.updateConfigDialogVisible = false;
              this.$message.warning(this.$t('customCluster.manage.upgradingConfig'));
              this.getSubclusterInstances();
            }
          })
          .catch(() => {
            this.priceLoading = false;
            this.priceNone = true;
          });
      }, 300);
    },

    /**
     * 跳转代金券链接
     * */
    windowOpenLink() {
      window.open('https://cloud.tencent.com/document/product/555/7428');
    },

    // 格式化过期时间
    // 当过期时间为1周内的红色，半个月内黄色，其他的黑色
    formatExpiredTime(time) {
      const now = dayjs();
      const expiredDate = dayjs(time);
      const diffDays = expiredDate.diff(now, 'days');
      if (diffDays <= 0) {
        return {
          expireTime: expiredDate.format('YYYY-MM-DD HH:mm:ss'),
          diffDays,
          tag: 'danger',
          color: 'rgb(245, 108, 108)',
          tagValue: '待回收',
        };
      }
      if (diffDays <= 7) {
        return {
          expireTime: expiredDate.format('YYYY-MM-DD HH:mm:ss'),
          color: 'rgb(245, 108, 108)',
          diffDays,
          tag: 'danger',
        };
      }
      if (diffDays <= 15) {
        return {
          expireTime: expiredDate.format('YYYY-MM-DD HH:mm:ss'),
          color: 'rgb(230, 162, 60)',
          diffDays,
          tag: 'warning',
        };
      }
      if (diffDays > 15) {
        return { expireTime: expiredDate.format('YYYY-MM-DD HH:mm:ss'), diffDays, tag: '', color: '' };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-style {
  ::v-deep .el-notification {
    width: 200px;
  }
}
.MFA_popover--img {
  width: 150px;
  height: 150px;
}

.terminate_dialog--div {
  background-color: #d4e3fc;
  height: 50px;
  line-height: 50px;
  color: #001f97;
  padding-left: 20px;
}

.manage-container {
  height: 100%;

  .manage-container_main {
    height: 100%;

    .table-container {
      height: 100%;

      .manage-table {
        height: calc(100% - 128px);
        overflow-y: auto;

        ::v-deep .el-table__body-wrapper {
          height: calc(100% - 68px);
          overflow-y: auto;
        }
      }

      .pagination {
        padding: 20px 10px;
        background: #fff;
        text-align: right;

        ::v-deep .el-pagination__total {
          float: left;
        }
      }
    }
  }
}

.refresh {
  padding: 0;
  font-size: 20px;
}

.select-batch {
  width: 240px !important;
  margin-right: 10px;

  ::v-deep .el-input {
    width: 240px !important;
  }
}

.select-status {
  width: 200px !important;
  margin-right: 10px;

  ::v-deep .el-input {
    width: 200px !important;
  }
}

.btn-group {
  flex: 1;
  min-width: 558px;
}

.manage-container_main {
  display: flex;
  flex-direction: column;
  height: 100%;
  //overflow: auto;
}

.table-container {
  flex: 1;
}

.networkInterfaceCls {
  min-height: 300px;

  ::v-deep .el-checkbox-group {
    font-size: 12px;
  }
}

.networkInterfaceCBox {
  flex: 1;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.networkInterfaceCTitle {
  background: #f5f7fa;
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
}

.steps {
  :deep .el-step__title {
    font-size: 12px;
  }
}

.price_cls {
  color: #ff7200;
  font-size: 24px;
}

.steps_cls {
  margin-left: 28%;
}

.instancesRenew-cls {
  padding: 10px 20px 20px;
  background: #d5e7ff;
  color: #4863a7;
  font-size: 12px;

  p {
    i {
      font-size: 18px;
      margin-right: 16px;
    }
  }

  ul {
    margin-left: 6px;
    list-style-type: circle;

    li {
      margin-top: 8px;
    }
  }
}

.stepsActive_3-cls {
  padding: 20px;
  background: #d5e7ff;
  color: #4863a7;
  font-size: 14px;

  p {
    i {
      font-size: 18px;
      margin-right: 16px;
    }
  }

  ul {
    margin-left: 66px;
    list-style-type: circle;

    li {
      margin-top: 8px;
    }
  }
}

.tableMessage {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.instanceTypeRadio {
  &:deep .el-radio__label {
    display: none;
  }
}

::v-deep .warning-row {
  color: #c9c9c9e6;
  cursor: not-allowed;
}

::v-deep .success-row {
  cursor: pointer;
}

.text-wrapper {
  max-width: 300px;
}
</style>
